define('hooks',[],function ()
{


    var hooks = {}, app;

    var ComponentsHooks = function ()
    {
    }

    // Setup
    // Call when setup the main app
    ComponentsHooks.prototype.setup = function (a)
    {
        this.setuped = true;
        app = a;
        if (this.started) {
            // started & setuped are asynchronous
            app.hooksStarted();
        }
    }

    // Start
    // Call after all components are loaded
    ComponentsHooks.prototype.start = function ()
    {
        this.started = true;
        if (this.setuped) {
            // started & setuped are asynchronous
            app.hooksStarted();
        }
    }

    // register a hook
    ComponentsHooks.prototype.registerHook = function (hookName, func)
    {
        if (typeof hooks[hookName] == 'undefined') hooks[hookName] = [];
        hooks[hookName].push(func);
    }

    // execute a hook
    ComponentsHooks.prototype.execHook = function (hookName, params, callback)
    {
        var hook = hooks[hookName];
        if (typeof hook == 'undefined') return;

        hook.forEach(function (func, index)
        {
            func.call(null, params, callback);
        });
    }
    
    // register a Widget Instance, with model & view
    ComponentsHooks.prototype.registerWidgetInstance = function (widgetClassName, widgetInstanceView, widgetInstanceModel){
        if(typeof widgetInstanceView != 'undefined') {
            this.registerHook('factoryWidgetInstanceView', function (widgetInstance, response) {
                if (widgetInstance.getClassName() == widgetClassName) {
                    //
                    // widgetInstanceView peut-être un objet key=>view
                    var templatedWidgetInstanceView = widgetInstanceView[widgetInstance.getTemplate()];
                    if(widgetInstanceView.length == 0){
                        // ou bien une seule vue
                        templatedWidgetInstanceView = widgetInstanceView;
                    }
                    if(!templatedWidgetInstanceView) return;
                    response.call(null, templatedWidgetInstanceView);
                }
            })
        }
        if(typeof widgetInstanceModel != 'undefined') {
            this.registerHook('factoryWidgetInstanceModel', function (widgetAttr, response) {
                if (widgetAttr.widget_class_name == widgetClassName) {
                    // widgetInstanceModel peut-être un objet key=>view
                    var templatedWidgetInstanceModel = widgetInstanceModel[widgetAttr.params.template];
                    if(widgetInstanceModel.length == 0){
                        // ou bien un seul model
                        templatedWidgetInstanceModel = widgetInstanceModel;
                    }
                    response.call(null, templatedWidgetInstanceModel);
                }
            })
        }
    }

    // singleton de tous les Hooks
    return new ComponentsHooks();
});
